import useReportQueries from './use-report-queries';
import useEnrichedTestItems from './use-enrich-test-items';
import useReportStats from './use-report-stats';
import useValidationResults from '../utils/useValidationResults';
import { useMemo } from 'react';

const useLiveReportData = (reportId: string, includedTestsOnly = false) => {
  const {
    allTestItems,
    report,
    testSuites,
    isLoading: isDataLoading,
    error,
  } = useReportQueries(reportId);

  const { missingData, isValidationLoading, revalidateData } = useValidationResults(
    allTestItems,
    testSuites ?? []
  );

  const enrichedTestItems = useEnrichedTestItems(
    allTestItems,
    testSuites,
    missingData,
    includedTestsOnly
  );

  const testSuitesWithInUse = useMemo(() => {
    const includedSuiteIds = new Set(
      enrichedTestItems
        .filter(item => item.exclusionReason === 'included')
        .map(item => item.testSpecification?.testSuiteId)
    );
    return testSuites?.map(testSuite => ({
      ...testSuite,
      inUse: includedSuiteIds.has(testSuite.id),
    }));
  }, [testSuites, enrichedTestItems]);

  const { bookmarks, missingSegments, missingDataCount } = useReportStats(
    enrichedTestItems,
    missingData
  );

  return {
    data: enrichedTestItems,
    totalDataCount: allTestItems?.length ?? 0,
    report,
    error,
    testSuites: testSuitesWithInUse,
    isLoading: isDataLoading || isValidationLoading,
    bookmarks,
    missingSegments,
    missingDataCount,
    enrichedTestItems,
    missingData,
    revalidateData,
  };
};

export default useLiveReportData;
